import { History } from 'history'
import { combineReducers } from 'redux'
import { routerReducer, RouterState } from 'react-router-redux'

import { authenticationReducer, AuthenticationReducerType } from './authentication/reducer'
import { commonReducer, ICommonReducer } from './common/reducer'
import { clientsReducer, IClientsReducer } from './clients/reducer'
import { teamReducer, ITeamReducer } from './team/reducer'
import { profileReducer, IProfileReducer } from './profile/reducer'
import { taskManagerReducer, ITaskManager } from './taskManager/reducer'
import { storeReducer, IStoreReducer } from './store/reducer'

export interface RootState {
  common: ICommonReducer
  auth: AuthenticationReducerType
  clients: IClientsReducer
  team: ITeamReducer
  profile: IProfileReducer
  taskManager: ITaskManager
  store: IStoreReducer
  routerReducer: RouterState
}

// eslint-disable-next-line
export default (histoåry: History): any =>
  combineReducers({
    common: commonReducer,
    auth: authenticationReducer,
    clients: clientsReducer,
    team: teamReducer,
    profile: profileReducer,
    taskManager: taskManagerReducer,
    store: storeReducer,
    routerReducer,
  })
